import React from "react";

const OverviewYTS = () => {
  return (
    <div className="flex md:space-x-2">
      <div className="md:w-3/4">
        <div className="border-2 p-2 border-sdorange inline-block mb-1 ">
          <p>Course Overview</p>
        </div>

        <div>
          <img src="/image-fix/random-images/young-trade-specialist.jpg" />
        </div>
        <div id="overview">
          <p className="text-justify">
            The Young Emerging Trade Specialist course provides a comprehensive
            understanding of international trade dynamics, policies, and
            practices. Participants will explore key concepts such as trade
            agreements, tariffs, & trade negotiations, while also delving into
            emerging trends reshaping the global trade landscape. Through case
            studies & interactive sessions, students will develop practical
            skills essential for navigating the intricacies of international
            trade relations.
          </p>
        </div>
      </div>
      <div className="md:w-1/4 hidden p-2 rounded-lg border-2 border-sdorange bg-sdbodywhite md:flex items-center">
        {" "}
        <img
          src="/image-fix/academic-programmes/executive-education/schima.png"
          className="w- w-full"
        />
      </div>
    </div>
  );
};

export default OverviewYTS;
